import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetails from './pages/ProductDetails';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Search from './pages/Search';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import AddressBook from './pages/AddressBook';
import Checkout from './pages/Checkout';
import OAuthSuccess from './pages/OAuthSuccess';
import Design from './pages/Design';
import TShirtDesigner from './pages/TShirtDesigner';

// Admin Components
import AdminLogin from './Admin/AdminLogin';
//import AdminSignup from './Admin/AdminSignup';
import AdminDashboard from './Admin/AdminDashboard';
import Admin from './Admin/Admin';
import OrderManagement from './Admin/OrderManagement';
import UserManagement from './Admin/UserManagement';

import './App.css';

// Scroll to Top Component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Admin Route Protection Component
function AdminRoute({ children }) {
  const adminToken = localStorage.getItem('adminToken');
  
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
}

// Layout wrapper for public pages (includes Header and Footer)
function PublicLayout({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Routes>
              {/* Public Routes - with Header and Footer */}
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/shop" element={<PublicLayout><Shop /></PublicLayout>} />
              <Route path="/product/:id" element={<PublicLayout><ProductDetails /></PublicLayout>} />
              <Route path="/cart" element={<PublicLayout><Cart /></PublicLayout>} />
              <Route path="/design" element={<PublicLayout><Design /></PublicLayout>} />
              <Route path="/design/tshirt" element={<TShirtDesigner />} />
              <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
              <Route path="/signup" element={<PublicLayout><Signup /></PublicLayout>} />
              <Route path="/search" element={<PublicLayout><Search /></PublicLayout>} />
              <Route path="/profile" element={<PublicLayout><Profile /></PublicLayout>} />
              <Route path="/orders" element={<PublicLayout><Orders /></PublicLayout>} />
              <Route path="/address-book" element={<PublicLayout><AddressBook /></PublicLayout>} />
              <Route path="/checkout" element={<PublicLayout><Checkout /></PublicLayout>} />
              <Route path="/auth/success" element={<PublicLayout><OAuthSuccess /></PublicLayout>} />

              {/* Admin Routes - No Header/Footer */}
              <Route path="/admin/login" element={<AdminLogin />} />
              {/* <Route path="/admin/signup" element={<AdminSignup />} /> */}
              
              {/* Protected Admin Routes */}
              <Route 
                path="/admin/dashboard" 
                element={<AdminRoute><AdminDashboard /></AdminRoute>} 
              />
              <Route 
                path="/admin/products" 
                element={<AdminRoute><Admin /></AdminRoute>} 
              />
              <Route 
                path="/admin/orders" 
                element={<AdminRoute><OrderManagement /></AdminRoute>} 
              />
              <Route 
                path="/admin/users" 
                element={<AdminRoute><UserManagement /></AdminRoute>} 
              />
              
              {/* Redirect /admin to /admin/dashboard */}
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;